import { HttpClient, HttpParams, HttpHeaders, HttpResponse} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PaginacaoMovimentacao } from '../page/movimentacao/paginacaoMovimentacao';
import { Movimentacao } from '../page/movimentacao/movimentacao';

@Injectable({
  providedIn: 'root'
})
export class MovimentacaoService {

  apiURL: string = environment.apiBaseUrl + 'movimentacao';

  constructor(private http: HttpClient) { }

  save(movimentacao: Movimentacao): Observable<Movimentacao> {
    return this.http.post<Movimentacao>(this.apiURL, movimentacao);
  }

  list(page: number, size: number): Observable<PaginacaoMovimentacao> {
    const params = new HttpParams().set('page', page.toString()).set('size', size.toString());
    return this.http.get<any>(`${this.apiURL}?${params.toString()}`);
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiURL}/${id}`);
  }

  findSale(page: number, size: number , dataInicio: string, dataFim: string): Observable<PaginacaoMovimentacao> {
    const params = new HttpParams().set('page', page.toString()).set('size', size.toString()).set('dataInicio', dataInicio).set('dataFim', dataFim);
    return this.http.get<any>(`${this.apiURL}/consulta?${params.toString()}`);
  } 

}